import { styled } from '@linaria/react';
import { CSSSpacings } from 'types/Theme';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wj8garz",
  propsAsIs: false
});
export const MainContentContainer = /*#__PURE__*/styled('div')({
  name: "MainContentContainer",
  class: "m1gm6uqk",
  propsAsIs: false
});
export const horizontalSectionPaddingStyles = (spacing: CSSSpacings, paddingXSm = 's500') => `
  padding-left: ${spacing[paddingXSm]};
  padding-right: ${spacing[paddingXSm]};
`;
const _exp4 = /*#__PURE__*/() => ({
  side
}) => side === 'start' ? '-10px' : '10px';
export const SideShadow = /*#__PURE__*/styled('div')({
  name: "SideShadow",
  class: "s1w9liih",
  propsAsIs: false,
  vars: {
    "s1w9liih-0": [_exp4()]
  }
});
export const ResetSectionPadding = /*#__PURE__*/styled('div')({
  name: "ResetSectionPadding",
  class: "r1qjm7iy",
  propsAsIs: false
});
const _exp8 = /*#__PURE__*/() => ResetSectionPadding;
export const BoxSectionPadding = /*#__PURE__*/styled(_exp8())({
  name: "BoxSectionPadding",
  class: "bbk1imp",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.tsx");